import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../api/queryKeys';
import { orderService } from '../api/services/orderService';
import type { OrderSummaryDto, OrdersQuery, OrdersSort } from '../api/types/dine.types';

/**
 * GET /orders — open orders by default, polled every 10 s while visible.
 * `useOrders('wait')` / `useOrders('table')`, or pass a full query
 * (`{ status: 'all' }` for the shift figures on More).
 */
export function useOrders(sortOrQuery: OrdersSort | OrdersQuery = 'wait', enabled = true) {
  const q: OrdersQuery = typeof sortOrQuery === 'string' ? { sort: sortOrQuery } : sortOrQuery;
  return useQuery<OrderSummaryDto[], Error>({
    queryKey: queryKeys.orders(q),
    queryFn: () => orderService.list(q),
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
    staleTime: 5_000,
    enabled,
  });
}
